export const TAB_CONFIG = {
  MAX_DIARIO_TJ: {
    id: 'maxdiario-tj',
    label: 'Máximo diario tj',
    component: 'MaxDiarioTab',
    permissions: ['CONCENTRATOR'],
    featureKey: 'MENU_MAX_DIARIO_TJ_ENABLED',
    title: 'Solicitudes de máximo diario por terminal de juego',
  },
  LISTADO_MINIMO_VENTA: {
    id: 'listado-minimo-venta',
    label: 'Listado mínimo venta',
    component: 'MinimumSaleTab',
    permissions: ['CONCENTRATOR', 'ADMIN'],
    title: 'Listado de venta mínima',
  },
  // agregar nuevos tabs aquí
};